<template>
  <v-expansion-panels v-model="detail_panel" multiple>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <div>
          <v-icon>mdi-motorbike</v-icon><span class="headerTitle">{{ labels.motorRiskDetTitle }}</span>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="tarfList"
                    v-model="mainForm.tarf"
                    :label="labels.tarf"
                    item-text="label"
                    item-value="value"
                    data-vv-name="tarf"
                    :data-vv-as="labels.tarf"
                    :error-messages="errors.collect('tarf')"
                    v-validate="'required'"
                    :loading="loading"
                    @input="doTarf"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="cvrTypeList"
                    v-model="mainForm.cvrType"
                    :label="labels.cvrType"
                    item-text="label"
                    item-value="value"
                    data-vv-name="cvrType"
                    :data-vv-as="labels.cvrType"
                    :error-messages="errors.collect('cvrType')"
                    v-validate="'required'"
                    :loading="loading"
                    @input="doCvrType"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field
                    v-model="mainForm.vehRegNo"
                    :label="labels.vehRegNo"
                    :error-messages="errors.collect('vehRegNo')"
                    data-vv-name="vehRegNo"
                    :data-vv-as="labels.vehRegNo"
                    v-validate="valVehRegNo"
                    @blur="doValVehRegNo"
                    :loading="vehRegNoLoading"
                  ></v-text-field>
                  <warning v-model="warnVehRegNo" @ok="doAcceptVehRegNo" @cancel="doCancelVehRegNo">{{ warnVehRegNoMsg }}</warning>
                  <warning v-model="warnSuspectVeh" @ok="doAcceptSuspectVeh">{{ warnSuspectVehMsg }}</warning>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field v-model="mainForm.cocNo" :label="labels.cocNo" disabled></v-text-field>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="certRefList"
                    v-model="mainForm.certRef"
                    :label="labels.certRef"
                    item-text="label"
                    item-value="value"
                    data-vv-name="certRef"
                    :data-vv-as="labels.certRef"
                    :error-messages="errors.collect('certRef')"
                    v-validate="'required'"
                    :loading="loading"
                    @input="doCertRef"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field
                    v-model="mainForm.trailerRegNo"
                    :label="labels.trailerRegNo"
                    :error-messages="errors.collect('trailerRegNo')"
                    data-vv-name="trailerRegNo"
                    :data-vv-as="labels.trailerRegNo"
                    v-validate="'max:20'"
                  ></v-text-field>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field
                    v-model="mainForm.logBook"
                    :label="labels.logBook"
                    :error-messages="errors.collect('logBook')"
                    data-vv-name="logBook"
                    :data-vv-as="labels.logBook"
                    v-validate="'max:20'"
                  ></v-text-field>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field
                    v-model="mainForm.engNo"
                    :label="labels.engNo"
                    :error-messages="errors.collect('engNo')"
                    data-vv-name="engNo"
                    :data-vv-as="labels.engNo"
                    v-validate="'max:30'"
                  ></v-text-field>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="yrList"
                    v-model="mainForm.yrManuf"
                    :label="labels.yrManuf"
                    item-text="label"
                    item-value="value"
                    data-vv-name="yrManuf"
                    :data-vv-as="labels.yrManuf"
                    :error-messages="errors.collect('yrManuf')"
                    :loading="loading"
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field
                    v-model="mainForm.chasNo"
                    :label="labels.chasNo"
                    :error-messages="errors.collect('chasNo')"
                    data-vv-name="chasNo"
                    :data-vv-as="labels.chasNo"
                    v-validate="'max:30'"
                    @blur="doWarnChasNo"
                  ></v-text-field>
                  <warning v-model="warnChasNo" @ok="doAcceptChasNo">{{ warnChasNoMsg }}</warning>
                </v-flex>
                <v-flex lg4 xs12> </v-flex>
                <v-flex lg2 xs12>
                  <v-autocomplete
                    :items="mthList"
                    v-model="mainForm.regMth"
                    :label="labels.regMth"
                    item-text="label"
                    item-value="value"
                    data-vv-name="regMth"
                    :data-vv-as="labels.regMth"
                    :error-messages="errors.collect('regMth')"
                    :loading="loading"
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg2 xs12>
                  <v-autocomplete
                    :items="regYrList"
                    v-model="mainForm.regYr"
                    :label="labels.regYr"
                    item-text="label"
                    item-value="value"
                    data-vv-name="regYr"
                    :data-vv-as="labels.regYr"
                    :error-messages="errors.collect('regYr')"
                    v-validate="valRegYr"
                    :loading="loading"
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg2 xs12>
                  <v-autocomplete
                    :items="vehModelList"
                    v-model="mainForm.modelNo"
                    :label="labels.modelNo"
                    item-text="label"
                    item-value="value"
                    data-vv-name="modelNo"
                    :data-vv-as="labels.modelNo"
                    :data-vv-on="mainForm.modelNo"
                    :error-messages="errors.collect('modelNo')"
                    v-validate="valVehMake"
                    @change="doGetVehModel"
                    :loading="loading"
                    clearable
                  >
                    <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                      <v-icon color="info" @click="doShowVehModel">mdi-magnify</v-icon>
                    </v-slide-x-reverse-transition>
                  </v-autocomplete>
                </v-flex>
                <v-flex lg2 xs12>
                  <v-autocomplete
                    :items="vehMakeList"
                    v-model="mainForm.vehMake"
                    :label="labels.vehMake"
                    item-text="label"
                    item-value="value"
                    data-vv-name="vehMake"
                    :data-vv-as="labels.vehMake"
                    :error-messages="errors.collect('vehMake')"
                    v-validate="valVehMake"
                    :loading="loading"
                    clearable
                    :disabled="makeModMand"
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg8 xs12>
                  <v-text-field
                    v-model="mainForm.modelDesc"
                    :label="labels.modelDesc"
                    :error-messages="errors.collect('modelDesc')"
                    data-vv-name="modelDesc"
                    :data-vv-as="labels.modelDesc"
                    v-validate="valVehMake + '|max:60'"
                    :disabled="makeModMand"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 xs12>
                  <v-text-field
                    v-model="mainForm.engCc"
                    :label="labels.engCc"
                    :error-messages="errors.collect('engCc')"
                    data-vv-name="engCc"
                    v-int-mask="{ intScale: 16 }"
                    type="tel"
                    v-validate="'mask_decimal:2|mask_max_value:9999999999999999.99|mask_min_value:0.00'"
                    :data-vv-as="labels.engCc"
                    :disabled="makeModMand"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex lg2 xs12>
                  <v-text-field
                    ref="tonnage"
                    v-model="mainForm.tonnage"
                    :label="labels.tonnage"
                    :error-messages="errors.collect('tonnage')"
                    v-num-mask="{ negative: false, intScale: 16, decScale: 2 }"
                    v-validate="'mask_decimal:2|mask_max_value:9999999999999999.99|mask_min_value:0.00'"
                    data-vv-name="tonnage"
                    :data-vv-as="labels.tonnage"
                    :disabled="makeModMand"
                    @blur="doWarnEngCcTons"
                  ></v-text-field>
                  <!-- 2021-01-20 LYT OS-643 -->
                  <warning v-model="warnEngCcTons" @ok="doAcceptEngCcTons">{{ warnEngCcTonsMsg }}</warning>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="vehBodyList"
                    v-model="mainForm.vehBody"
                    :label="labels.vehBody"
                    item-text="label"
                    item-value="value"
                    data-vv-name="vehBody"
                    :data-vv-as="labels.vehBody"
                    :error-messages="errors.collect('vehBody')"
                    v-validate="valVehMake"
                    :loading="loading"
                    clearable
                    :disabled="makeModMand"
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field
                    ref="maxLaden"
                    v-model="mainForm.maxLaden"
                    :label="labels.maxLaden"
                    v-num-mask="{ negative: false, intScale: 16, decScale: 2 }"
                    :error-messages="errors.collect('maxLaden')"
                    data-vv-name="maxLaden"
                    :data-vv-as="labels.maxLaden"
                    v-validate="'mask_decimal:2|mask_max_value:9999999999999999.99|mask_min_value:0.00'"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex lg2 xs12>
                  <v-text-field
                    v-model="mainForm.noSeats"
                    :label="labels.noSeats"
                    :error-messages="errors.collect('noSeats')"
                    data-vv-name="noSeats"
                    :data-vv-as="labels.noSeats"
                    v-int-mask="{ intScale: 10 }"
                    type="tel"
                    v-validate="'mask_max_value:9999999999|mask_min_value:0'"
                    :loading="loading"
                    :disabled="makeModMand"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 xs12>
                  <v-text-field
                    v-model="mainForm.colour"
                    :label="labels.colour"
                    :error-messages="errors.collect('colour')"
                    data-vv-name="colour"
                    :data-vv-as="labels.colour"
                    v-validate="'max:20'"
                  ></v-text-field>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="vehGrpList"
                    v-model="mainForm.vehGrp"
                    :label="labels.vehGrp"
                    item-text="label"
                    item-value="value"
                    data-vv-name="vehGrp"
                    :data-vv-as="labels.vehGrp"
                    :error-messages="errors.collect('vehGrp')"
                    v-validate="valVehMake"
                    :disabled="makeModMand"
                    :loading="loading"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field
                    ref="unLaden"
                    v-model="mainForm.unLaden"
                    :label="labels.unLaden"
                    :error-messages="errors.collect('unLaden')"
                    data-vv-name="unLaden"
                    :data-vv-as="labels.unLaden"
                    v-num-mask="{ negative: false, intScale: 16, decScale: 2 }"
                    v-validate="'mask_decimal:2|mask_max_value:9999999999999999.99|mask_min_value:0.00'"
                  ></v-text-field>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="vehUseList"
                    v-model="mainForm.vehUse"
                    :label="labels.vehUse"
                    item-text="label"
                    item-value="value"
                    data-vv-name="vehUse"
                    :data-vv-as="labels.vehUse"
                    :error-messages="errors.collect('vehUse')"
                    v-validate="'required'"
                    :loading="loading"
                    clearable
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field
                    v-model="mainForm.ownName"
                    :label="labels.ownName"
                    :error-messages="errors.collect('ownName')"
                    data-vv-name="ownName"
                    :data-vv-as="labels.ownName"
                    v-validate="'max:60'"
                  ></v-text-field>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field
                    v-model="mainForm.mileage"
                    :label="labels.mileage"
                    :error-messages="errors.collect('mileage')"
                    data-vv-name="mileage"
                    :data-vv-as="labels.mileage"
                    v-int-mask="{ intScale: 10 }"
                    type="tel"
                    v-validate="'mask_max_value:9999999999|mask_min_value:0'"
                    :loading="loading"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex lg2 xs12>
                  <v-autocomplete
                    :items="ncbYrList"
                    v-model="mainForm.ncbYr"
                    :label="labels.ncbYr"
                    item-text="label"
                    item-value="value"
                    data-vv-name="ncbYr"
                    :data-vv-as="labels.ncbYr"
                    :error-messages="errors.collect('ncbYr')"
                    v-validate="'required'"
                    @change="doNcbYr"
                    :loading="ncbYrLoading"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg2 xs12>
                  <v-text-field
                    v-model="mainForm.ncbPct"
                    :label="labels.ncbPct"
                    :error-messages="errors.collect('ncbPct')"
                    data-vv-name="ncbPct"
                    :data-vv-as="labels.ncbPct"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 xs12>
                  <v-text-field
                    v-model="mainForm.vehOwnIcno"
                    :label="labels.vehOwnIcno"
                    :error-messages="errors.collect('vehOwnIcno')"
                    data-vv-name="vehOwnIcno"
                    :data-vv-as="labels.vehOwnIcno"
                    v-validate="'max:20'"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 xs12>
                  <v-text-field
                    v-model="mainForm.vehOwnId"
                    :label="labels.vehOwnId"
                    :error-messages="errors.collect('vehOwnId')"
                    data-vv-name="vehOwnId"
                    :data-vv-as="labels.vehOwnId"
                    v-validate="'max:20'"
                  ></v-text-field>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field
                    ref="vehPurPrice"
                    v-model="mainForm.vehPurPrice"
                    :label="labels.vehPurPrice"
                    :error-messages="errors.collect('vehPurPrice')"
                    data-vv-name="vehPurPrice"
                    :data-vv-as="labels.vehPurPrice"
                    v-num-mask="{ negative: false, intScale: 16, decScale: 2 }"
                    v-validate="'mask_decimal:2|mask_max_value:9999999999999999.99|mask_min_value:0.00'"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-checkbox v-model="mainForm.retnNcd" :label="labels.retnNcd"></v-checkbox>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field
                    v-model="mainForm.hpOwn"
                    :label="labels.hpOwn"
                    :error-messages="errors.collect('hpOwn')"
                    data-vv-name="hpOwn"
                    :data-vv-as="labels.hpOwn"
                    v-validate="'max:40'"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 xs12>
                  <cal-picker v-model="mainForm.ltaTranDate" :label="labels.ltaTranDate" disabled></cal-picker>
                </v-flex>
                <!-- <v-flex lg2 xs12>
                  <cal-picker v-model="mainForm.upldDate" :label="labels.upldDate" disabled></cal-picker>
                </v-flex> -->
                <v-spacer class="mt-2"></v-spacer>
                <v-flex lg12 xs12>
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <div>
                          <v-icon>mdi-account-key</v-icon><span class="headerTitle">{{ labels.mtrDrvTitle }}</span>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card>
                          <v-card-text>
                            <v-container fluid grid-list-sm>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-toolbar dense color="grey lighten-3" flat>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" dark class="mb-2" @click="doAddDriver" :loading="policy.loading">
                                      New Driver
                                      <v-icon right>mdi-plus</v-icon>
                                    </v-btn>
                                  </v-toolbar>
                                  <v-data-table :headers="drivers.headers" :items="drivers.list" class="elevation-1" :loading="drivers.loading">
                                    <template v-slot:item="row">
                                      <tr>
                                        <td>{{ row.item.seqNo }}</td>
                                        <td>{{ row.item.drvName }}</td>
                                        <td>{{ row.item.drvYob }}</td>
                                        <td>{{ row.item.drvExp }}</td>
                                        <td>{{ row.item.drvDip }}</td>
                                        <td>{{ row.item.drvMstat }}</td>
                                        <td>{{ row.item.drvGender }}</td>
                                        <td>{{ row.item.drvOccp }}</td>
                                        <td class="table-action-header">
                                          <table-action
                                            :rowData="row"
                                            review
                                            @review="doSelectDriver(row.item)"
                                            remove
                                            @remove="doPromptRemoveDriver(row.item)"
                                          ></table-action>
                                        </td>
                                      </tr>
                                    </template>
                                  </v-data-table>
                                  <confirm v-model="promptRemoveDriver" @ok="doRemoveDriver">{{ deleteDriver }}</confirm>
                                </v-flex>
                                <v-flex xs12 v-if="showAddDriver">
                                  <v-card>
                                    <v-toolbar dense color="grey lighten-5" flat>
                                      <v-icon>mdi-pencil</v-icon>
                                      <v-toolbar-title class="toolbar-title-3">{{ labels.driverTitle }}</v-toolbar-title>
                                      <v-spacer></v-spacer>
                                      <v-btn text icon @click="showAddDriver = false">
                                        <v-icon>mdi-close</v-icon>
                                      </v-btn>
                                    </v-toolbar>
                                    <v-card-text>
                                      <v-card-text>
                                        <v-container fluid grid-list-sm>
                                          <v-layout row wrap>
                                            <v-flex lg4 xs12>
                                              <v-text-field
                                                v-model="driverForm.seqNo"
                                                data-vv-scope="driverForm"
                                                :label="labels.seqNo"
                                                :error-messages="errors.collect('driverForm.seqNo')"
                                                data-vv-name="seqNo"
                                                :data-vv-as="labels.seqNo"
                                                disabled
                                              ></v-text-field>
                                            </v-flex>
                                            <v-flex lg8 xs12>
                                              <v-text-field
                                                v-model="driverForm.drvName"
                                                data-vv-scope="driverForm"
                                                :label="labels.drvName"
                                                :error-messages="errors.collect('driverForm.drvName')"
                                                data-vv-name="drvName"
                                                :data-vv-as="labels.drvName"
                                                v-validate="'required'"
                                              >
                                              </v-text-field>
                                            </v-flex>
                                            <v-flex lg4 xs12>
                                              <v-autocomplete
                                                :items="years"
                                                v-model="driverForm.drvYob"
                                                :label="labels.drvYOB"
                                                item-text="label"
                                                item-value="value"
                                                data-vv-name="drvYob"
                                                :data-vv-as="labels.drvYOB"
                                                :error-messages="errors.collect('driverForm.drvYob')"
                                                clearable
                                              >
                                              </v-autocomplete>
                                              <!-- <cal-picker v-model="driverForm.drvDob" data-vv-scope="driverForm" :label="labels.drvDob"
                                            :error-messages="errors.collect('driverForm.drvDob')" data-vv-name="drvDob" :data-vv-as="labels.drvDob"
                                            v-validate="valDrvDob" @input="doDrvDob"></cal-picker> -->
                                            </v-flex>
                                            <v-flex lg4 xs12>
                                              <v-autocomplete
                                                :items="maritalStatusList"
                                                v-model="driverForm.drvMstat"
                                                :label="labels.drvMstat"
                                                item-text="label"
                                                item-value="value"
                                                data-vv-name="drvMstat"
                                                :data-vv-as="labels.drvMstat"
                                                :error-messages="errors.collect('driverForm.drvMstat')"
                                                clearable
                                              >
                                              </v-autocomplete>
                                            </v-flex>
                                            <v-flex lg4 xs12>
                                              <v-autocomplete
                                                :items="genderList"
                                                v-model="driverForm.drvGender"
                                                :label="labels.drvGender"
                                                item-text="label"
                                                item-value="value"
                                                data-vv-name="drvGender"
                                                :data-vv-as="labels.drvGender"
                                                :error-messages="errors.collect('driverForm.drvGender')"
                                                clearable
                                              >
                                              </v-autocomplete>
                                            </v-flex>
                                            <v-flex lg4 xs12>
                                              <v-autocomplete
                                                :items="occpList"
                                                v-model="driverForm.drvOccp"
                                                :label="labels.drvOccp"
                                                item-text="label"
                                                item-value="value"
                                                data-vv-name="drvOccp"
                                                :data-vv-as="labels.drvOccp"
                                                :error-messages="errors.collect('driverForm.drvOccp')"
                                                clearable
                                              >
                                              </v-autocomplete>
                                            </v-flex>
                                            <v-flex lg4 xs12>
                                              <v-text-field
                                                v-model="driverForm.drvExp"
                                                :label="labels.drvExp"
                                                :error-messages="errors.collect('drvExp')"
                                                data-vv-name="drvExp"
                                                v-int-mask="{ intScale: 2 }"
                                                type="tel"
                                                :data-vv-as="labels.drvExp"
                                                @change="doDrvExp"
                                              >
                                              </v-text-field>
                                            </v-flex>
                                            <v-flex lg4 xs12>
                                              <v-text-field
                                                v-model="driverForm.drvDip"
                                                :label="labels.drvDip"
                                                :error-messages="errors.collect('drvDip')"
                                                data-vv-name="drvDip"
                                                v-int-mask="{ intScale: 10 }"
                                                type="tel"
                                                :data-vv-as="labels.drvDip"
                                              >
                                              </v-text-field>
                                            </v-flex>
                                            <v-flex xs12>
                                              <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn depressed @click.prevent="doResetDriver" :loading="policy.loading"
                                                  ><span class="btn-normal-error">Reset</span></v-btn
                                                >
                                                <v-btn depressed type="submit" @click.prevent="doSaveDriver" :loading="policy.loading"
                                                  ><span class="btn-normal-primary">{{ labels.save }}</span></v-btn
                                                >
                                              </v-card-actions>
                                            </v-flex>
                                          </v-layout>
                                        </v-container>
                                      </v-card-text>
                                    </v-card-text>
                                  </v-card>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-flex>
              </v-layout>
              <v-dialog v-model="showVehModel" persistent width="80%">
                <v-card>
                  <v-card-title class="headline grey lighten-2" primary-title>
                    {{ labels.vehModel }}
                    <v-spacer></v-spacer>
                    <v-btn text icon @click="showVehModel = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-flex xs12>
                      <form>
                        <v-expansion-panels>
                          <v-expansion-panel>
                            <v-expansion-panel-header>
                              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-card>
                                <v-card-text>
                                  <v-container fluid grid-list-sm>
                                    <v-layout row wrap>
                                      <v-flex lg4 xs12>
                                        <v-text-field
                                          data-vv-scope="queryVehModelFilterForm"
                                          v-model="filters.vehMake"
                                          :label="filtersLabel.vehMake"
                                          :error-messages="errors.collect('filters.vehMake')"
                                          data-vv-name="filters.vehMake"
                                          :data-vv-as="filtersLabel.vehMake"
                                          v-validate="'entry|max:4'"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex lg4 xs12>
                                        <v-text-field
                                          data-vv-scope="queryVehModelFilterForm"
                                          v-model="filters.vehModel"
                                          :label="filtersLabel.vehModel"
                                          :error-messages="errors.collect('filters.vehModel')"
                                          data-vv-name="filters.vehModel"
                                          :data-vv-as="filtersLabel.vehModel"
                                          v-validate="'entry|max:4'"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex lg4 xs12>
                                        <v-text-field
                                          data-vv-scope="queryVehModelFilterForm"
                                          v-model="filters.vehModelDesc"
                                          :label="filtersLabel.vehModelDesc"
                                          :error-messages="errors.collect('filters.vehModelDesc')"
                                          data-vv-name="filters.vehModelDesc"
                                          :data-vv-as="filtersLabel.vehModelDesc"
                                          v-validate="'entry|max:60'"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex lg4 xs12>
                                        <v-text-field
                                          data-vv-scope="queryVehModelFilterForm"
                                          v-model="filters.bodyType"
                                          :label="filtersLabel.bodyType"
                                          :error-messages="errors.collect('filters.bodyType')"
                                          data-vv-name="filters.bodyType"
                                          :data-vv-as="filtersLabel.bodyType"
                                          v-validate="'entry|max:20'"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex lg4 xs12>
                                        <v-text-field
                                          data-vv-scope="queryVehModelFilterForm"
                                          v-model="filters.engineCc"
                                          :label="filtersLabel.engineCc"
                                          :error-messages="errors.collect('filters.engineCc')"
                                          data-vv-name="filters.engineCc"
                                          :data-vv-as="filtersLabel.engineCc"
                                          type="tel"
                                          v-validate="'mask_decimal:2|mask_min_value:0.00|max:18'"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex lg4 xs12>
                                        <v-text-field
                                          data-vv-scope="queryVehModelFilterForm"
                                          v-model="filters.tonnage"
                                          :label="filtersLabel.tonnage"
                                          :error-messages="errors.collect('filters.tonnage')"
                                          data-vv-name="filters.tonnage"
                                          :data-vv-as="filtersLabel.tonnage"
                                          type="tel"
                                          v-validate="'mask_decimal:2|mask_min_value:0.00|max:18'"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex lg4 xs12>
                                        <v-text-field
                                          data-vv-scope="queryVehModelFilterForm"
                                          v-model="filters.noSeats"
                                          :label="filtersLabel.noSeats"
                                          :error-messages="errors.collect('filters.noSeats')"
                                          data-vv-name="filters.noSeats"
                                          :data-vv-as="filtersLabel.noSeats"
                                          v-validate="'numeric|max:2'"
                                          v-int-mask="{ intScale: 2 }"
                                          type="tel"
                                        ></v-text-field>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-card-text>
                                <v-card-actions right>
                                  <v-spacer></v-spacer>
                                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                                  <v-btn color="primary" text @click.prevent="doFilters">Apply Filters</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </form>
                    </v-flex>
                    <v-flex xs12 class="mt-2">
                      <v-data-table
                        :headers="headers"
                        :items="items"
                        :options.sync="pagination"
                        :footer-props="{'items-per-page-options': itemsPerPage }"
                        :server-items-length="totalItems"
                        :loading="loading"
                        class="elevation-1"
                        :no-data-text="noDataText"
                      >
                        <template v-slot:item="row">
                          <tr>
                            <td>{{ row.item.vehMake }}</td>
                            <td>{{ row.item.vehModel }}</td>
                            <td>{{ row.item.vehModelDesc }}</td>
                            <td>{{ row.item.bodyType }}</td>
                            <td>{{ row.item.engineCc }}</td>
                            <td>{{ row.item.tonnage }}</td>
                            <td>{{ row.item.noSeats }}</td>
                            <td>{{ row.item.vehGrp }}</td>
                            <td style="margin: 0 auto">
                              <v-tooltip>
                                <template v-slot:activator="{ on }">
                                  <v-btn v-on="on" icon color="primary" text type="submit" @click.prevent="doSelectVehModel(row.item)">
                                    <v-icon>mdi-content-copy</v-icon>
                                  </v-btn>
                                </template>
                              </v-tooltip>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-dialog>
              <v-dialog v-model="policy.loading" persistent width="300">
                <v-card color="primary" dark>
                  <v-card-text>
                    Processing...
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-container>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'
import { formatDisplayDate, formatDisplayDate2 } from '@/utils/date'
import * as TableConst from '@/mixins/table'
import { gender, maritalStatus } from '@/const/underwriting'
import { isEqual } from '@/utils/compare'
import { removeFormatNumber } from '@/utils/number'
export default {
  data() {
    return {
      labels: {
        motorRiskDetTitle: 'Motor Risk Details',
        tarf: 'Tariff',
        cvrType: 'Cover Type',
        vehRegNo: 'Vehicle Registration No.',
        cocNo: 'CI No.',
        certRef: 'Certificate Reference',
        trailerRegNo: 'Trailer Registration No.',
        logBook: 'Log Book No.',
        engNo: 'Engine No.',
        yrManuf: 'Year of Manufacture',
        chasNo: 'Chassis No.',
        regMth: 'Registration Month',
        regYr: 'Registration Year',
        vehMake: 'Make',
        modelNo: 'Model',
        modelDesc: 'Model Description',
        vehBody: 'Body Type',
        engCc: 'Engine CC',
        tonnage: 'Tonnage',
        maxLaden: 'Maximum Laden Weight',
        noSeats: 'No. of Seats',
        colour: 'Colour',
        vehGrp: 'Vehicle Group',
        unLaden: 'Unladen Weight',
        vehUse: 'Vehicle Usage',
        ownName: 'Owner Name',
        mileage: 'Mileage',
        ncbYr: 'NCB Years',
        ncbPct: 'NCB %',
        vehOwnIcno: 'Owner NRIC No.',
        vehOwnId: 'Owner ID',
        vehPurPrice: 'New Car Purchase Price',
        retnNcd: 'Retain NCB on Renewal',
        hpOwn: 'Hire Purchase Owner',
        ltaTranDate: 'LTA Transmission Date',
        upldDate: 'LTA Update Date',
        vehModel: 'Vehicle Model',
        mtrDrvTitle: 'Named Driver',
        editDriver: 'Edit Driver',
        delDriver: 'Delete Driver',
        addDriver: 'Add Driver',
        driverTitle: 'Driver Details',
        seqNo: 'Sequence No.',
        drvName: 'Driver Name',
        drvDob: 'DOB',
        drvYOB: 'Year of Birth',
        drvMstat: 'Marital Status',
        drvGender: 'Gender',
        drvOccp: 'Occupation',
        drvExp: 'Years of Experience',
        drvDip: 'DIP',
        save: 'Save',
        reset: 'Reset'
      },
      mainForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        tarf: undefined,
        cvrType: undefined,
        vehRegNo: undefined,
        cocNo: undefined,
        certRef: undefined,
        trailerRegNo: undefined,
        logBook: undefined,
        engNo: undefined,
        yrManuf: undefined,
        chasNo: undefined,
        regMth: undefined,
        regYr: undefined,
        vehMake: undefined,
        modelNo: null,
        modelDesc: undefined,
        vehBody: undefined,
        engCc: undefined,
        tonnage: undefined,
        maxLaden: undefined,
        noSeats: undefined,
        colour: undefined,
        vehGrp: undefined,
        unLaden: undefined,
        vehUse: undefined,
        ownName: undefined,
        mileage: undefined,
        ncbYr: undefined,
        ncbPct: undefined,
        vehOwnIcno: undefined,
        vehOwnId: undefined,
        vehPurPrice: undefined,
        retnNcd: undefined,
        hpOwn: undefined,
        ltaTranDate: undefined,
        upldDate: undefined
      },
      filtersLabel: {
        vehMake: 'Vehicle Make',
        vehModel: 'Vehicle Model',
        vehModelDesc: 'Vehicle Model Description',
        bodyType: 'Vehicle Body Type',
        engineCc: 'Vehicle Engine CC',
        tonnage: 'Vehicle Tonnage',
        noSeats: 'No. of Seats',
        vehGrp: 'Vehicle Group'
      },
      filters: {
        vehMake: undefined,
        vehModel: undefined,
        vehModelDesc: undefined,
        bodyType: undefined,
        engineCc: undefined,
        tonnage: undefined,
        noSeats: undefined,
        vehGrp: undefined
      },
      error: {
        vehRegNo: undefined,
        regYr1: 'Registration Year is mandatory.(86)',
        regYr2: 'Cannot be earlier than Year of Manufacture.(10275)',
        regYr3: 'Must not be greater than current year Plus 1.(10276)',
        engCCTons: 'Engine Cc and Tonnage cannot both be zero.(10457)'
      },
      loading: false,
      vehRegNoLoading: false,
      ncbYrLoading: false,
      tarfList: [],
      cvrTypeList: [],
      certRefList: [],
      // yrManufList: [],
      vehMakeList: [],
      vehModelList: [],
      vehModelDtoList: [],
      vehBodyList: [],
      vehGrpList: [],
      vehUseList: [],
      ncbYrList: [],
      makeModMand: undefined,
      vehRegMand: undefined,
      vehValMand: undefined,
      namedDrvMand: undefined,
      valVehReg: undefined,
      allowYr: undefined,
      vehGrp: undefined,
      calcAgeBySysDate: undefined,
      showVehModel: false,
      totalItems: 0,
      headers: [
        { text: 'Vehicle Make', align: 'left', value: 'vehMake' },
        { text: 'Vehicle Model', value: 'vehModel' },
        { text: 'Vehicle Model Description', value: 'vehModelDesc' },
        { text: 'Vehicle Body Type', value: 'bodyType' },
        { text: 'Vehicle Engine CC', value: 'engineCc' },
        { text: 'Vehicle Tonnage', value: 'tonnage' },
        { text: 'No. of Seats', value: 'noSeats' },
        { text: 'Vehicle Group', value: 'vehGrp' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      drivers: {
        headers: [
          { text: 'Seq No.', align: 'left', value: 'seqNo' },
          { text: 'Driver Name', value: 'drvName' },
          { text: 'Year of Birth', value: 'drvYOB' },
          { text: 'Experience', value: 'drvExp' },
          { text: 'DIP', value: 'drvDip' },
          { text: 'Marital Status', value: 'drvMstat' },
          { text: 'Gender', value: 'drvGender' },
          { text: 'Occupation', value: 'drvOccp' },
          { text: 'Action', value: 'action', align: 'center', sortable: false }
        ],
        list: [],
        loading: false
      },
      policy: {
        loading: false
      },
      promptRemoveDriver: undefined,
      deleteDriver: undefined,
      panel: 1,
      driverForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        seqNo: undefined,
        drvName: undefined,
        drvDob: undefined,
        drvYob: undefined,
        drvIcno: undefined,
        drvExp: undefined,
        drvDip: undefined,
        drvMstat: undefined,
        drvGender: undefined,
        drvLicType: undefined,
        drvOldIc: undefined,
        drvPostCode: undefined,
        drvOccp: undefined,
        drvFirstYr: undefined
      },
      resetDriverForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        seqNo: undefined,
        drvName: undefined,
        drvDob: undefined,
        drvYob: undefined,
        drvIcno: undefined,
        drvExp: undefined,
        drvDip: undefined,
        drvMstat: undefined,
        drvGender: undefined,
        drvLicType: undefined,
        drvOldIc: undefined,
        drvPostCode: undefined,
        drvOccp: undefined,
        drvFirstYr: undefined
      },
      occpList: [
        { value: 'I', label: 'I - INDOOR' },
        { value: 'O', label: 'O - OUTDOOR' }
      ],
      selectedDriver: undefined,
      showAddDriver: false,
      warnVehRegNo: false,
      acceptVehRegNo: false,
      warnVehRegNoMsg: undefined,
      warnSuspectVeh: false,
      acceptSuspectVeh: false,
      warnSuspectVehMsg: '',
      warnChasNo: false,
      acceptChasNo: false,
      warnChasNoMsg: undefined,
      // 2021-01-20 LYT OS-643
      warnEngCcTons: false,
      acceptEngCcTons: false,
      warnEngCcTonsMsg: 'Engine Cc and Tonnage are both zero.(10457)',
      pagination: {
        sortDesc: [false],
        page: 1
      },
      detail_panel: []
    }
  },
  props: {
    polRisk: Object
  },
  computed: {
    years() {
      const year = new Date().getFullYear()
      return Array.from({ length: year - 1900 }, (value, index) => 1901 + index)
    },
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    polMtrDrv() {
      return this.$store.state.underwriting.policy.polMtrDrv
    },
    getTarf() {
      return this.tarfList.filter((tarf) => {
        return tarf.value === this.mainForm.tarf
      })
    },
    valVehRegNo() {
      var chkStr = 'max:20'
      if (this.vehRegMand) {
        chkStr = chkStr + '|required'
      }
      if (this.error.vehRegNo !== undefined) {
        chkStr = chkStr + '|valField:' + this.error.vehRegNo
      }
      return chkStr
    },
    yrList() {
      let result = []
      result.push({
        label: '0000',
        value: 0
      })
      var iYear = new Date().getFullYear()
      var iYearEnd = iYear - 70
      while (iYear >= iYearEnd) {
        result.push({
          label: iYear,
          value: iYear
        })
        iYear = iYear - 1
      }
      return result
    },
    mthList() {
      let result = []
      result.push({
        label: '00',
        value: 0
      })
      var iMth = 1
      var iMthEnd = 12
      var iMthStr = ''
      while (iMth <= iMthEnd) {
        if (iMth < 10) {
          iMthStr = '0' + iMth
        } else {
          iMthStr = iMth
        }
        result.push({
          label: iMthStr,
          value: iMth
        })
        iMth = iMth + 1
      }
      return result
    },
    regYrList() {
      let result = []
      result.push({
        label: '0000',
        value: 0
      })
      var iYear = new Date().getFullYear() + 1
      var iYearEnd = iYear - 70
      while (iYear >= iYearEnd) {
        result.push({
          label: iYear,
          value: iYear
        })
        iYear = iYear - 1
      }
      return result
    },
    valRegYr() {
      var iYear = new Date().getFullYear() + 1
      if (this.allowYr && this.polMaster.dri) {
        if (this.mainForm.regYr === 0) {
          return 'required|valField:' + this.error.regYr1
        } else if (this.mainForm.regYr < this.mainForm.yrManuf) {
          return 'required|valField:' + this.error.regYr2
        } else if (this.mainForm.regYr > iYear) {
          return 'required|valField:' + this.error.regYr3
        } else {
          return 'required'
        }
      } else {
        if (this.mainForm.regYr < this.mainForm.yrManuf) {
          return 'valField:' + this.error.regYr2
        } else if (this.mainForm.regYr > iYear) {
          return 'valField:' + this.error.regYr3
        } else {
          return ''
        }
      }
    },
    getVehModelDto() {
      return this.vehModelDtoList.filter((vehModelDto) => {
        return vehModelDto.vehModel === this.mainForm.modelNo
      })
    },
    valVehMake() {
      // if (this.mainForm.makeModMand) {
      if (this.makeModMand) {
        return 'required'
      } else {
        return ''
      }
    },
    // 2021-01-21
    // valEngCCTons() {
    //   if ((this.mainForm.engCc === undefined || parseInt(this.mainForm.engCc) === 0) &&
    //    (this.mainForm.tonnage === undefined || parseFloat(this.mainForm.tonnage) === 0) &&
    //    (this.mainForm.modelNo !== null && this.mainForm.modelNo !== undefined && this.mainForm.modelNo !== '')) {
    //     return 'mask_decimal:2|mask_max_value:9999999999999999.99|mask_min_value:0.00|valField:' + this.error.engCCTons
    //   } else {
    //     return 'mask_decimal:2|mask_max_value:9999999999999999.99|mask_min_value:0.00'
    //   }
    // },
    getNcbYr() {
      return this.ncbYrList.filter((ncbYr) => {
        return ncbYr.value === this.mainForm.ncbYr
      })
    },
    getNewDriver() {
      return this.drivers.list.filter((driver) => {
        return driver.newDrv === true
      })
    },
    disabledDriver() {
      if (this.driverForm.seqNo === undefined) {
        return true
      } else {
        return false
      }
    },
    genderList() {
      let result = []
      Object.keys(gender).forEach(function (key) {
        const status = gender[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    maritalStatusList() {
      let result = []
      Object.keys(maritalStatus).forEach(function (key) {
        const status = maritalStatus[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
    // valDrvDob() {
    //   if (this.driverForm.drvName !== undefined || this.driverForm.drvName !== '') {
    //     return 'required'
    //   } else {
    //     return ''
    //   }
    // }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.fetchData()
    },
    'mainForm.tarf': function (value) {
      this.getNcbYrList()
    },
    'mainForm.cvrType': function (value) {
      this.getNcbYrList()
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.getPolMtrRisk()
    },
    async getPolMtrRisk() {
      const apiUrl = this.$store.state.underwriting.policyMotorRiskSettings.menu.getPolMotorRisk
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.polRisk.riskGrpNo,
            riskNo: this.polRisk.riskNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data.polMtrRisk) {
            this.mainForm.polNo = result.data.polMtrRisk.data.polNo
            this.mainForm.renCnt = result.data.polMtrRisk.data.renCnt
            this.mainForm.endtCnt = result.data.polMtrRisk.data.endtCnt
            this.mainForm.riskGrpNo = result.data.polMtrRisk.data.riskGrpNo
            this.mainForm.riskNo = result.data.polMtrRisk.data.riskNo
            this.mainForm.tarf = result.data.polMtrRisk.data.tarf
            this.mainForm.cvrType = result.data.polMtrRisk.data.cvrType
            this.mainForm.vehRegNo = result.data.polMtrRisk.data.vehRegNo
            this.mainForm.cocNo = result.data.polMtrRisk.data.cocNo
            this.mainForm.certRef = result.data.polMtrRisk.data.certRef
            this.mainForm.trailerRegNo = result.data.polMtrRisk.data.trailerRegNo
            this.mainForm.logBook = result.data.polMtrRisk.data.logBook
            this.mainForm.engNo = result.data.polMtrRisk.data.engNo
            this.mainForm.yrManuf = result.data.polMtrRisk.data.yrManuf
            this.mainForm.chasNo = result.data.polMtrRisk.data.chasNo
            this.mainForm.regMth = result.data.polMtrRisk.data.regMth
            this.mainForm.regYr = result.data.polMtrRisk.data.regYr
            this.mainForm.vehMake = result.data.polMtrRisk.data.vehMake
            this.mainForm.modelNo = result.data.polMtrRisk.data.modelNo
            this.mainForm.modelDesc = result.data.polMtrRisk.data.modelDesc
            this.mainForm.vehBody = result.data.polMtrRisk.data.vehBody
            this.mainForm.engCc = result.data.polMtrRisk.data.engCc
            this.mainForm.tonnage = result.data.polMtrRisk.data.tonnage
            this.mainForm.maxLaden = result.data.polMtrRisk.data.maxLaden
            this.mainForm.noSeats = result.data.polMtrRisk.data.noSeats
            this.mainForm.colour = result.data.polMtrRisk.data.colour
            this.mainForm.vehGrp = result.data.polMtrRisk.data.vehGrp
            this.mainForm.unLaden = result.data.polMtrRisk.data.unLaden
            this.mainForm.vehUse = result.data.polMtrRisk.data.vehUse
            this.mainForm.ownName = result.data.polMtrRisk.data.ownName
            this.mainForm.mileage = result.data.polMtrRisk.data.mileage
            this.mainForm.ncbYr = result.data.polMtrRisk.data.ncbYr
            this.mainForm.ncbPct = result.data.polMtrRisk.data.ncbPct
            this.mainForm.vehOwnIcno = result.data.polMtrRisk.data.vehOwnIcno
            this.mainForm.vehOwnId = result.data.polMtrRisk.data.vehOwnId
            // this.mainForm.vehPurPrice = result.data.polMtrRisk.data. Missing field
            this.mainForm.retnNcd = result.data.polMtrRisk.data.retnNcd
            this.mainForm.hpOwn = result.data.polMtrRisk.data.hpOwn
            this.mainForm.ltaTranDate = result.data.polMtrRisk.data.ltaTranDate
            this.mainForm.upldDate = result.data.polMtrRisk.data.upldDate

            // 2020-12-22 LYT Fixed on blur to zero
            // this.$refs.tonnage.$el.cleave.setRawValue(this.mainForm.tonnage)
            // this.$refs.maxLaden.$el.cleave.setRawValue(this.mainForm.maxLaden)
            // this.$refs.unLaden.$el.cleave.setRawValue(this.mainForm.unLaden)
            // this.$refs.vehPurPrice.$el.cleave.setRawValue(this.mainForm.vehPurPrice)
          }

          if (result.data.polMtrDrvList) {
            this.drivers.list = []
            const { data } = result.data.polMtrDrvList
            data.map((driver) => {
              const convertDriver = {
                seqNo: driver.seqNo,
                drvName: driver.drvName,
                // drvDob: driver.drvDob,
                // drvDobFormat: formatDisplayDate(driver.drvDob),
                drvYob: driver.drvYob,
                drvIcno: driver.drvIcno,
                drvExp: driver.drvExp,
                drvDip: driver.drvDip,
                drvMstat: driver.drvMstat,
                drvGender: driver.drvGender,
                drvLicType: driver.drvLicType,
                drvOldIc: driver.drvOldIc,
                drvPostCode: driver.drvPostCode,
                drvOccp: driver.drvOccp,
                drvFirstYr: driver.drvFirstYr,
                newDrv: driver.newDrv
              }
              this.drivers.list.push(convertDriver)
            })
          } else {
            this.drivers.list = []
          }
          this.hideInitLoading()
          this.loading = false
          this.getMtrParams().then(() => {
            this.doTarf()
            if (this.getTarf.length <= 0) {
              this.mainForm.tarf = ''
            }
          })
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }

        this.copymainForm = clone(this.mainForm)
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    hideInitLoading() {
      // Set parent policy.initLoading to false
      this.$emit('hide-init-loading')
    },
    async getMtrParams() {
      const apiUrl = this.$store.state.underwriting.policyMotorRiskSettings.menu.getMtrParams
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polType: this.polMaster.polType,
            busCls: this.polRisk.busCls
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))

          if (result.data) {
            this.$set(this, 'tarfList', result.data.tarfList)
            this.$set(this, 'cvrTypeList', result.data.cvrTypeList)
            this.valVehReg = result.data.valVehReg
            this.$set(this, 'certRefList', result.data.certRefList)
            this.$set(this, 'vehMakeList', result.data.vehMakeList)
            this.$set(this, 'vehModelList', result.data.vehModelList)
            this.$set(this, 'vehModelDtoList', result.data.vehModelDtoList)
            this.$set(this, 'vehBodyList', result.data.vehBodyList)
            this.$set(this, 'vehGrpList', result.data.vehGrpList)
            this.$set(this, 'vehUseList', result.data.vehUseList)
            this.allowYr = result.data.allowYr
            this.vehGrp = result.data.vehGrp
            this.calcAgeBySysDate = result.data.calcAgeBySysDate
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async fetchData() {
      const apiUrl = this.$store.state.underwriting.policyMotorRiskSettings.menu.vehModelList
      if (apiUrl) {
        try {
          this.filters.vehGrp = this.mainForm.vehGrp // 2020-09-21 LYT OS-421
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          let massageFilters = clone(this.filters)
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              this.$set(this, 'items', data)
            } else {
              this.$set(this, 'items', [])
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doTarf() {
      if (this.getTarf.length > 0) {
        this.makeModMand = this.getTarf[0].makeModMand
        this.vehRegMand = this.getTarf[0].vehRegMand
        this.vehValMand = this.getTarf[0].vehValMand
        this.namedDrvMand = this.getTarf[0].namedDrvMand
        // Changed SelectObj.java to BusClsTariffDto : SSY
        // this.makeModMand = this.getTarf[0].secondaryValue
        // this.vehRegMand = this.getTarf[0].thirdValue
        // this.vehValMand = this.getTarf[0].fourthValue
      }
    },
    doCvrType() {},
    doWarnVehRegNo() {
      if (this.valVehReg && !this.acceptVehRegNo && this.mainForm.vehRegNo.length > 8) {
        this.warnVehRegNoMsg = 'Vehicle Registration No. exceeds 8 characters entered. (10192)'
        this.warnVehRegNo = true
        return false
      } else if (this.warnSuspectVehMsg !== '') {
        this.warnSuspectVeh = true
        return false
      }
      return true
    },
    doValVehRegNo() {
      if (this.valVehReg && !this.acceptVehRegNo && this.mainForm.vehRegNo.length > 8) {
        this.warnVehRegNoMsg = 'Vehicle Registration No. exceeds 8 characters entered. (10192)'
        this.warnVehRegNo = true
        return false
      } else {
        this.doSuspectVeh()
      }
    },
    async doSuspectVeh() {
      if (this.mainForm.vehRegNo.length > 0) {
        const result = this.checkVehRegNo()
        return result
      } else {
        return true
      }
    },
    async checkVehRegNo() {
      this.warnSuspectVehMsg = ''
      let status = true
      const apiUrl = this.$store.state.underwriting.policyMotorRiskSettings.menu.valVehRegNo
      if (apiUrl) {
        try {
          this.vehRegNoLoading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            vehRegNo: this.mainForm.vehRegNo,
            comDate: undefined
          }
          if (this.polMaster.comDate !== undefined && this.polMaster.comDate !== null) {
            expand.comDate = formatDisplayDate2(this.polMaster.comDate)
          } else if (this.polMaster.endtDate !== undefined && this.polMaster.endtDate !== null) {
            expand.comDate = formatDisplayDate2(this.polMaster.endtDate)
          } else {
            expand.comDate = formatDisplayDate2(this.polMaster.tranDate)
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))

          if (result.data) {
            if (!this.acceptSuspectVeh && result.data.suspectVeh) {
              // this.$toast.warning('Suspect Vehicle Register indicates ' + result.data.suspTypeDesc + '. (10454)')
              this.warnSuspectVehMsg = 'Suspect Vehicle Register indicates ' + result.data.suspTypeDesc + '. (10454)'
              this.warnSuspectVeh = true
              status = false
            } else if (result.data.sameVeh) {
              this.error.vehRegNo = 'Vehicle Registration No. already insured under policy no. ' + result.data.sameVehPolNo + '. (10455)'
            } else {
              this.error.vehRegNo = undefined
            }
          }

          this.vehRegNoLoading = false
          return status
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doCertRef() {},
    doShowVehModel() {
      this.showVehModel = true
      this.$set(this, 'items', [])
      this.fetchData()
    },
    doClearFilters() {
      this.filters.vehMake = null
      this.filters.vehModel = null
      this.filters.vehModelDesc = null
      this.filters.bodyType = null
      this.filters.engineCc = null
      this.filters.tonnage = null
      this.filters.noSeats = null
      // this.filters.vehGrp = null
      this.fetchData()
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryVehModelFilterForm').then((result) => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData()
        }
      })
    },
    doSelectVehModel(data) {
      this.mainForm.vehMake = data.vehMake
      this.mainForm.modelNo = data.vehModel
      this.mainForm.modelDesc = data.vehModelDesc
      this.mainForm.vehBody = data.bodyType
      this.mainForm.engCc = data.engineCc
      this.mainForm.tonnage = data.tonnage
      this.mainForm.noSeats = data.noSeats
      this.mainForm.vehGrp = data.vehGrp
      this.showVehModel = false
    },
    doGetVehModel() {
      if (this.getVehModelDto.length > 0) {
        this.mainForm.vehMake = this.getVehModelDto[0].vehMake
        this.mainForm.modelDesc = this.getVehModelDto[0].vehModelDesc
        this.mainForm.vehBody = this.getVehModelDto[0].bodyType
        this.mainForm.engCc = this.getVehModelDto[0].engineCc
        this.mainForm.tonnage = this.getVehModelDto[0].tonnage
        this.mainForm.noSeats = this.getVehModelDto[0].noSeats
        this.mainForm.vehGrp = this.getVehModelDto[0].vehGrp
      } else {
        this.mainForm.vehMake = undefined
        this.mainForm.modelDesc = undefined
        this.mainForm.vehBody = undefined
        this.mainForm.engCc = undefined
        this.mainForm.tonnage = undefined
        this.mainForm.noSeats = undefined
        this.mainForm.vehGrp = undefined
      }
    },
    async getNcbYrList() {
      const apiUrl = this.$store.state.underwriting.policyMotorRiskSettings.menu.ncbYrList
      if (apiUrl) {
        try {
          this.ncbYrLoading = true
          const expand = {
            busCls: this.polRisk.busCls,
            tariff: this.mainForm.tarf,
            cover: this.mainForm.cvrType,
            effDate: formatDisplayDate(this.polMaster.tranDate)
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))

          if (result.data) {
            if (result.data.ncbYrList) {
              this.ncbYrList = result.data.ncbYrList
            } else {
              this.ncbYrList = []
            }
          }
          this.ncbYrLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doNcbYr() {
      if (this.getNcbYr.length > 0) {
        this.mainForm.ncbPct = this.getNcbYr[0].secondaryValue
      }
    },
    doWarnChasNo() {
      if (!this.acceptChasNo && (this.mainForm.chasNo === '' || this.mainForm.chasNo === undefined)) {
        // this.$toast.warning('Chassis No. not entered.(10331)')
        this.warnChasNoMsg = 'Chassis No. not entered. (10331)'
        this.warnChasNo = true
        return false
      }
      return true
    },
    async doPolMtrRiskSave() {
      try {
        if (isEqual(this.mainForm, this.copymainForm) === true) {
          return true
        } else {
          this.mainForm.tonnage = removeFormatNumber(this.mainForm.tonnage)
          const result = await this.$store.dispatch('savePolMtrRisk', this.mainForm)
          if (result) {
            return true
          } else {
            return false
          }
        }
      } catch (err) {
        return false
      }
    },
    async doAddDriver() {
      const apiUrl = this.$store.state.underwriting.policyMotorRiskSettings.menu.addDriver
      if (apiUrl) {
        try {
          this.policy.loading = true
          const expand = {
            polNo: this.mainForm.polNo,
            renCnt: this.mainForm.renCnt,
            endtCnt: this.mainForm.endtCnt,
            riskGrpNo: this.mainForm.riskGrpNo,
            riskNo: this.mainForm.riskNo
          }

          const result = await this.$http.get(expandURI(apiUrl, expand))

          if (result.data.polMtrDrvList) {
            this.drivers.list = []
            const { data } = result.data.polMtrDrvList
            data.map((driver) => {
              const convertDriver = {
                seqNo: driver.seqNo,
                drvName: driver.drvName,
                // drvDob: driver.drvDob,
                // drvDobFormat: formatDisplayDate(driver.drvDob),
                drvYob: driver.drvYob,
                drvIcno: driver.drvIcno,
                drvExp: driver.drvExp,
                drvDip: driver.drvDip,
                drvMstat: driver.drvMstat,
                drvGender: driver.drvGender,
                drvLicType: driver.drvLicType,
                drvOldIc: driver.drvOldIc,
                drvPostCode: driver.drvPostCode,
                drvOccp: driver.drvOccp,
                drvFirstYr: driver.drvFirstYr,
                newDrv: driver.newDrv
              }
              this.drivers.list.push(convertDriver)
            })
          } else {
            this.drivers.list = []
          }

          this.panel = 0

          this.driverForm.seqNo = this.getNewDriver[0].seqNo
          this.driverForm.drvName = this.getNewDriver[0].drvName
          // this.driverForm.drvDob = this.getNewDriver[0].drvDob
          this.driverForm.drvYob = this.getNewDriver[0].drvYob
          this.driverForm.drvIcno = this.getNewDriver[0].drvIcno
          this.driverForm.drvExp = this.getNewDriver[0].drvExp
          this.driverForm.drvDip = this.getNewDriver[0].drvDip
          this.driverForm.drvMstat = this.getNewDriver[0].drvMstat
          this.driverForm.drvGender = this.getNewDriver[0].drvGender
          this.driverForm.drvLicType = this.getNewDriver[0].drvLicType
          this.driverForm.drvOldIc = this.getNewDriver[0].drvOldIc
          this.driverForm.drvPostCode = this.getNewDriver[0].drvPostCode
          this.driverForm.drvOccp = this.getNewDriver[0].drvOccp
          this.driverForm.drvFirstYr = this.getNewDriver[0].drvFirstYr

          this.resetDriverForm.seqNo = this.driverForm.seqNo
          this.resetDriverForm.drvName = this.driverForm.drvName
          // this.resetDriverForm.drvDob = this.driverForm.drvDob
          this.resetDriverForm.drvYob = this.driverForm.drvYob
          this.resetDriverForm.drvIcno = this.driverForm.drvIcno
          this.resetDriverForm.drvExp = this.driverForm.drvExp
          this.resetDriverForm.drvDip = this.driverForm.drvDip
          this.resetDriverForm.drvMstat = this.driverForm.drvMstat
          this.resetDriverForm.drvGender = this.driverForm.drvGender
          this.resetDriverForm.drvLicType = this.driverForm.drvLicType
          this.resetDriverForm.drvOldIc = this.driverForm.drvOldIc
          this.resetDriverForm.drvPostCode = this.driverForm.drvPostCode
          this.resetDriverForm.drvOccp = this.driverForm.drvOccp
          this.resetDriverForm.drvFirstYr = this.driverForm.drvFirstYr

          this.policy.loading = false
          this.$toast.success('New driver successfully created.')
          this.showAddDriver = true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doSelectDriver(data) {
      this.panel = 0

      this.driverForm.seqNo = data.seqNo
      this.driverForm.drvName = data.drvName
      // this.driverForm.drvDob = data.drvDob
      this.driverForm.drvYob = data.drvYob
      this.driverForm.drvIcno = data.drvIcno
      this.driverForm.drvExp = data.drvExp
      this.driverForm.drvDip = data.drvDip
      this.driverForm.drvMstat = data.drvMstat
      this.driverForm.drvGender = data.drvGender
      this.driverForm.drvLicType = data.drvLicType
      this.driverForm.drvOldIc = data.drvOldIc
      this.driverForm.drvPostCode = data.drvPostCode
      this.driverForm.drvOccp = data.drvOccp
      this.driverForm.drvFirstYr = data.drvFirstYr

      this.resetDriverForm.seqNo = this.driverForm.seqNo
      this.resetDriverForm.drvName = this.driverForm.drvName
      // this.resetDriverForm.drvDob = this.driverForm.drvDob
      this.resetDriverForm.drvYob = this.driverForm.drvYob
      this.resetDriverForm.drvIcno = this.driverForm.drvIcno
      this.resetDriverForm.drvExp = this.driverForm.drvExp
      this.resetDriverForm.drvDip = this.driverForm.drvDip
      this.resetDriverForm.drvMstat = this.driverForm.drvMstat
      this.resetDriverForm.drvGender = this.driverForm.drvGender
      this.resetDriverForm.drvLicType = this.driverForm.drvLicType
      this.resetDriverForm.drvOldIc = this.driverForm.drvOldIc
      this.resetDriverForm.drvPostCode = this.driverForm.drvPostCode
      this.resetDriverForm.drvOccp = this.driverForm.drvOccp
      this.resetDriverForm.drvFirstYr = this.driverForm.drvFirstYr
      this.showAddDriver = true
    },
    doPromptRemoveDriver(data) {
      this.selectedDriver = data
      this.deleteDriver = 'Are you sure you want to delete named driver no. ' + data.seqNo + '?'
      this.promptRemoveDriver = true
    },
    async doRemoveDriver() {
      const apiUrl = this.$store.state.underwriting.policyMotorRiskSettings.menu.delDriver
      if (apiUrl) {
        try {
          this.policy.loading = true
          const expand = {
            polNo: this.mainForm.polNo,
            renCnt: this.mainForm.renCnt,
            endtCnt: this.mainForm.endtCnt,
            riskGrpNo: this.mainForm.riskGrpNo,
            riskNo: this.mainForm.riskNo,
            seqNo: this.selectedDriver.seqNo
          }

          const result = await this.$http.get(expandURI(apiUrl, expand))

          if (result.data.polMtrDrvList) {
            this.drivers.list = []
            const { data } = result.data.polMtrDrvList
            data.map((driver) => {
              const convertDriver = {
                seqNo: driver.seqNo,
                drvName: driver.drvName,
                // drvDob: driver.drvDob,
                // drvDobFormat: formatDisplayDate(driver.drvDob),
                drvYob: driver.drvYob,
                drvIcno: driver.drvIcno,
                drvExp: driver.drvExp,
                drvDip: driver.drvDip,
                drvMstat: driver.drvMstat,
                drvGender: driver.drvGender,
                drvLicType: driver.drvLicType,
                drvOldIc: driver.drvOldIc,
                drvPostCode: driver.drvPostCode,
                drvOccp: driver.drvOccp,
                drvFirstYr: driver.drvFirstYr,
                newDrv: driver.newDrv
              }
              this.drivers.list.push(convertDriver)
            })
          } else {
            this.drivers.list = []
          }

          this.panel = 1
          this.initDriverForm()
          this.policy.loading = false
          this.$toast.success('Named driver successfully deleted.')
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    // doDrvDob() {
    //   if (this.driverForm.drvDob) {
    //     let drvDob = new Date(this.driverForm.drvDob)
    //     this.driverForm.drvYob = drvDob.getFullYear()
    //   } else {
    //     this.driverForm.drvYob = 0
    //   }
    // },
    doDrvExp() {
      if (this.driverForm.drvExp !== undefined && this.driverForm.drvExp !== '') {
        if (this.calcAgeBySysDate) {
          this.driverForm.drvFirstYr = new Date().getFullYear() - this.driverForm.drvExp
        } else {
          if (this.polRisk.comDate !== undefined && this.polRisk.comDate !== null) {
            let comDate = new Date(this.polRisk.comDate)
            this.driverForm.drvFirstYr = comDate.getFullYear() - this.driverForm.drvExp
          } else {
            this.driverForm.drvFirstYr = 0
          }
        }
      } else {
        this.driverForm.drvFirstYr = 0
      }
    },
    doSaveDriver() {
      this.resetMessages()
      this.$validator.validateAll('driverForm').then((result) => {
        if (result) {
          this.policy.loading = true
          this.driverForm.polNo = this.mainForm.polNo
          this.driverForm.renCnt = this.mainForm.renCnt
          this.driverForm.endtCnt = this.mainForm.endtCnt
          this.driverForm.riskGrpNo = this.mainForm.riskGrpNo
          this.driverForm.riskNo = this.mainForm.riskNo
          this.doPolMtrDrvSave().then((success) => {
            if (success) {
              this.initDriverForm()
              this.displayDriverList()
              this.$toast.success('Named driver successfully saved')
              this.showAddDriver = false
            } else {
              this.$toast.error('Named driver save failed')
            }
            this.policy.loading = false
          })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPolMtrDrvSave() {
      try {
        const result = await this.$store.dispatch('savePolMtrDrv', this.driverForm)
        if (result) {
          return true
        } else {
          return false
        }
      } catch (err) {
        return false
      }
    },
    doResetDriver() {
      this.driverForm.seqNo = this.resetDriverForm.seqNo
      this.driverForm.drvName = this.resetDriverForm.drvName
      // this.driverForm.drvDob = this.resetDriverForm.drvDob
      this.driverForm.drvYob = this.resetDriverForm.drvYob
      this.driverForm.drvIcno = this.resetDriverForm.drvIcno
      this.driverForm.drvExp = this.resetDriverForm.drvExp
      this.driverForm.drvDip = this.resetDriverForm.drvDip
      this.driverForm.drvMstat = this.resetDriverForm.drvMstat
      this.driverForm.drvGender = this.resetDriverForm.drvGender
      this.driverForm.drvLicType = this.resetDriverForm.drvLicType
      this.driverForm.drvOldIc = this.resetDriverForm.drvOldIc
      this.driverForm.drvPostCode = this.resetDriverForm.drvPostCode
      this.driverForm.drvOccp = this.resetDriverForm.drvOccp
      this.driverForm.drvFirstYr = this.resetDriverForm.drvFirstYr
    },
    initDriverForm() {
      this.panel = 1

      this.driverForm.seqNo = undefined
      this.driverForm.drvName = undefined
      // this.driverForm.drvDob = undefined
      this.driverForm.drvYob = undefined
      this.driverForm.drvIcno = undefined
      this.driverForm.drvExp = undefined
      this.driverForm.drvDip = undefined
      this.driverForm.drvMstat = undefined
      this.driverForm.drvGender = undefined
      this.driverForm.drvLicType = undefined
      this.driverForm.drvOldIc = undefined
      this.driverForm.drvPostCode = undefined
      this.driverForm.drvOccp = undefined
      this.driverForm.drvFirstYr = undefined

      this.resetDriverForm.seqNo = this.driverForm.seqNo
      this.resetDriverForm.drvName = this.driverForm.drvName
      // this.resetDriverForm.drvDob = this.driverForm.drvDob
      this.resetDriverForm.drvYob = this.driverForm.drvYob
      this.resetDriverForm.drvIcno = this.driverForm.drvIcno
      this.resetDriverForm.drvExp = this.driverForm.drvExp
      this.resetDriverForm.drvDip = this.driverForm.drvDip
      this.resetDriverForm.drvMstat = this.driverForm.drvMstat
      this.resetDriverForm.drvGender = this.driverForm.drvGender
      this.resetDriverForm.drvLicType = this.driverForm.drvLicType
      this.resetDriverForm.drvOldIc = this.driverForm.drvOldIc
      this.resetDriverForm.drvPostCode = this.driverForm.drvPostCode
      this.resetDriverForm.drvOccp = this.driverForm.drvOccp
      this.resetDriverForm.drvFirstYr = this.driverForm.drvFirstYr
    },
    displayDriverList() {
      // this.drivers.list = []
      if (this.polMtrDrv.polMtrDrvList) {
        this.drivers.list = []
        const { data } = this.polMtrDrv.polMtrDrvList
        data.map((driver) => {
          const convertDriver = {
            seqNo: driver.seqNo,
            drvName: driver.drvName,
            // drvDob: driver.drvDob,
            // drvDobFormat: formatDisplayDate(driver.drvDob),
            drvYob: driver.drvYob,
            drvIcno: driver.drvIcno,
            drvExp: driver.drvExp,
            drvDip: driver.drvDip,
            drvMstat: driver.drvMstat,
            drvGender: driver.drvGender,
            drvLicType: driver.drvLicType,
            drvOldIc: driver.drvOldIc,
            drvPostCode: driver.drvPostCode,
            drvOccp: driver.drvOccp,
            drvFirstYr: driver.drvFirstYr,
            newDrv: driver.newDrv
          }
          this.drivers.list.push(convertDriver)
        })
      } else {
        this.drivers.list = []
      }
    },
    doAcceptVehRegNo() {
      this.acceptVehRegNo = true
      this.doSuspectVeh()
    },
    doCancelVehRegNo() {
      this.doSuspectVeh()
    },
    doAcceptSuspectVeh() {
      this.acceptSuspectVeh = true
    },
    doAcceptChasNo() {
      this.acceptChasNo = true
    },
    // 2021-01-20 LYT OS-643
    doWarnEngCcTons() {
      if (
        !this.acceptEngCcTons &&
        (this.mainForm.engCc === undefined || parseInt(this.mainForm.engCc) === 0) &&
        (this.mainForm.tonnage === undefined || parseFloat(this.mainForm.tonnage) === 0)
      ) {
        this.warnEngCcTons = true
        return false
      }
      return true
    },
    doAcceptEngCcTons() {
      this.acceptEngCcTons = true
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.policyMotorRiskSettings.init !== 1) {
      this.$store.dispatch('policyMotorRiskInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  created() {
    // Local validator
    const valField = {
      getMessage: (field, args) => {
        if (args === void 0) args = []
        var errMsg = args[0]
        return errMsg
      },
      validate: (value, args) => {
        if (value !== '') {
          if (args === void 0) args = []
          var errMsg = args[0]
          if (errMsg) {
            return false
          } else return true
        } else return true
      }
    }
    this.$validator.extend('valField', valField)
  },
  mixins: [MessageMixin, TableConst.default]
}
</script>
